import bypass from './axios'
import ibm from './axiosIBM'

const bypassHosts = ['localhost', 'nbtc.vptangddns.com']

export default bypassHosts.includes(window.location.hostname) ? bypass : ibm
